import React from 'react';
import PageContainer from "../../../hoc/PageContainer";

const News = () => (
    <div>
        <PageContainer page={"news"}>
            <h1 className="AboutUsTitle">NEWS</h1>

            <div className="AboutUsText">
                <a target="_blank" href="https://www.am730.com.hk/column/新聞/我和唐寶寶有個約會-破非洲鼓合奏世界紀錄-127703"><b>2018-05-28 AM730 我和唐寶寶有個約會-破非洲鼓合奏世界紀錄</b></a>
                <br/>
                <br/>
                <a target="_blank" href="https://skypost.ulifestyle.com.hk/article/2284927/【回饋社會】重視身教執垃圾拯救海灘%20教授媽媽帶女兒做義工"><b>2019-03-14 晴報 【回饋社會】重視身教執垃圾拯救海灘 教授媽媽帶女兒做義工</b></a>
                <br/>
                <br/>
                <a target="_blank" href="https://hk.on.cc/hk/bkn/cnt/news/20190317/bkn-20190317163040785-0317_00822_001.html"><b>2019-03-17東方日報 清潔海灘見玩具亂棄 家長受啟發減買</b></a>
                <br/>
                <br/>
                <a target="_blank" href="https://m.mingpao.com/pns/教育/article/20190411/s00011/1554920835596/第22屆校園記者-清潔海灘辦相展-反思塑膠污"><b>2019-04-11明報 清潔海灘辦相展-反思塑膠污</b></a>
                <br/>
                <br/>
                <a target="_blank" href="https://skypost.ulifestyle.com.hk/article/2336642/戰勝血癌心漏症捱過化療%E3%80%80唐氏小飛魚屢奪獎成世界冠軍"><b>2019-04-26 晴報 唐氏小飛魚屢奪獎成世界冠軍</b></a>
            </div>

        </PageContainer>
    </div>
);

export default News;
